export default __webpack_public_path__ + "static/media/leave-lg-2-dark.c5c32501.png";